export default __webpack_public_path__ + "static/media/Ballroll_00192.5bef45d4.png";